import useOffersLoader from "../common/useOffersLoader";
import useDefaultCountryTo from "./useDefaultCountryTo";
import useDefaultDeliveryMethod from "./useDefaultDeliveryMethod";
import useDefaultPackageSize from "./useDefaultPackageSize";
import usePackageSizesLoader from "./usePackageSizesLoader";
import useDefaultParcelWeight from "./useDefaultParcelWeight";

const usePackageInfoSideEffects = (): void => {
  usePackageSizesLoader();
  useDefaultCountryTo();
  useDefaultPackageSize();
  useDefaultParcelWeight();
  useDefaultDeliveryMethod();
  useOffersLoader();
};
export default usePackageInfoSideEffects;
